import i from "styled-components";
import { Text as r } from "./atoms-v243.js";
import { Link as t } from "./atoms-v224.js";
const c = i.div`
  align-items: center;
  border-top: 1px solid ${({ theme: o }) => {
  var n;
  return (n = o == null ? void 0 : o.get) == null ? void 0 : n.call(o, "tokens.border.light.light");
}};
  display: flex;
  justify-content: space-between;
  padding: 24px 4px 0;
`, d = i(r)`
  color: ${({ theme: o }) => {
  var n;
  return (n = o == null ? void 0 : o.get) == null ? void 0 : n.call(o, "tokens.text.light.secondary");
}};
`, p = i(t)`
  color: ${({ theme: o }) => {
  var n;
  return (n = o == null ? void 0 : o.get) == null ? void 0 : n.call(o, "tokens.text.light.secondary");
}};
  font-family: 'PP Neue Montreal', sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 560;
  letter-spacing: 0.102px;
  line-height: 100%;
  text-decoration: none;
`, x = i(t)`
  text-decoration: none;
`, g = i.div`
  align-items: center;
  display: flex;
  gap: 12px;
`;
export {
  x as LinkWithoutUnderline,
  g as LinksContainer,
  p as SecondaryLink,
  d as SecondaryText,
  c as StyledFooter
};
